/**
 * A global namespace for `contextmenu` event.
 */
const contextmenuEvent = "contextmenu";
export default contextmenuEvent;
